/**
 * Get the angle of a point relative to the center point.
 */
export function getAngleAtPoint(point: { x: number; y: number }) {
  const radians = Math.atan2(point.y, point.x);
  // -1 to flip the angle to clockwise.
  return radians * (180 / Math.PI) * -1 + 180;
}

/*
 * Snap the given degree to the closest degree in the given snap values.
 */
export function snapToClosestDegree({
  degree,
  snapThreshold,
  snapValues,
}: {
  degree: number;
  snapThreshold: number;
  snapValues: number[];
}): number {
  for (const snapValue of snapValues) {
    if (Math.abs(degree - snapValue) <= snapThreshold) {
      return snapValue;
    }
  }
  return degree;
}
